module.exports = __webpack_public_path__ + "img/generali-investments.a8d65f8f.svg";